module.exports = "https://trybtryb-legacy.web.app/img/candy-cane.fd32dcf4.webp";